import React, { useEffect } from 'react';
import { getBreakpoints, Responsive, useBreakpoint } from '@noths/polaris-client-responsive';
import { Breakpoint } from '@noths/polaris-client-styles';
import dynamic from 'next/dynamic';

import { Modal } from 'src/components/molecules/Modal';
import { ModalLoader } from 'src/components/molecules/ModalLoader';
import { FilterListContainer } from '../containers/FilterListContainer';
import * as styles from '../styles/Filter.styles';

const FilterModal = dynamic(
  async () => (await import(/* webpackChunkName: "FilterModal" */ './FilterModal')).FilterModal,
  { loading: () => <ModalLoader /> },
);

export type FilterProps = {
  isModalOpen: boolean;
  closeFilterModal: () => void;
  onShowList: () => void;
};

export const Filter = ({ isModalOpen, closeFilterModal, onShowList }: FilterProps) => {
  const breakpoint = useBreakpoint();
  const breakpointsWithModal = getBreakpoints({ maxBreakpoint: Breakpoint.MEDIUM });

  const handleModalClose = () => {
    closeFilterModal();
  };

  useEffect(() => {
    if (!breakpointsWithModal.includes(breakpoint)) {
      closeFilterModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return (
    <div css={styles.filterWrapper}>
      <Responsive minBreakpoint={Breakpoint.LARGE}>
        <FilterListContainer />
      </Responsive>
      <Modal
        isModalOpen={isModalOpen}
        closeModal={handleModalClose}
        onAfterClose={onShowList}
        contentLabel="Product filtering options"
      >
        <FilterModal />
      </Modal>
    </div>
  );
};
